<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Search</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<div class="content">
  <h2>Customized Search</h2>
  <div class="content__tools-wrap">
    <div class="content__row">
      <div class="c-input-check-inline">
        <input id="hasIcon" class="c-input-check-inline__input" type="checkbox" name="hasIcon"
          [(ngModel)]="hasIcon">
        <label for="hasIcon" class="c-input-check-inline__label">Has Icon</label>
      </div>
      <div class="c-input-check-inline">
        <input id="hasExternalButton" class="c-input-check-inline__input" type="checkbox" name="hasExternalButton"
          [(ngModel)]="hasExternalButton">
        <label for="hasExternalButton" class="c-input-check-inline__label">Has External Button</label>
      </div>
    </div>
  </div>
  <form [formGroup]="formElement">
    <maced-search placeholder="Search" globalLang="en" id="searchInput" name="searchText" [hasIcon]="hasIcon" [autocomplete]="autoComplete.on"
      type="text" value="" [errorMessage]="errorMessageEnglish" [label]="searchInputLabelEnglish" buttonUrl = "/search"
      formControlName="inputVal" (onClearSearch)="doOnClearSearch()" (searchInputValue)="onSearchSubmit($event)" [hasExternalButton]="hasExternalButton">
    </maced-search>
    <p *ngIf="hasExternalButton" aria-live="assertive">
      Search Value:
      {{ inputText }}
    </p>

    <maced-search placeholder="खोज" globalLang="hi" id="searchInput1" name="searchText1" [hasIcon]="hasIcon" [autocomplete]="autoComplete.on"
      type="text" value="" [errorMessage]="errorMessageHindi" [label]="searchInputLabelHindi" buttonUrl = "/search"
      formControlName="inputValtwo" (searchInputValue)="onSearchSubmit($event)" [hasExternalButton]="hasExternalButton">
    </maced-search>
    <p *ngIf="hasExternalButton" aria-live="assertive">
      Search Value:
      {{ inputText1 }}
    </p>

    <maced-search placeholder="búsqueda" globalLang="es" id="searchInput2" name="searchText2" [hasIcon]="hasIcon" [autocomplete]="autoComplete.off"
      type="text" value="" [errorMessage]="errorMessageSpanish" [label]="searchInputLabelSpanish" buttonUrl = "/search"
      formControlName="inputValthree" (searchInputValue)="onSearchSubmit($event)" [hasExternalButton]="hasExternalButton">
    </maced-search>
    <p *ngIf="hasExternalButton" aria-live="assertive">
      Search Value:
      {{ inputText2 }}
    </p>



  </form>
</div>

<div class="content">
  <h2>No JS :: Input</h2>

  <form action="/search" method="get">
    <maced-search placeholder="Search" globalLang="en" id="noJsInput" name="noJsInput" [hasIcon]="false" [autocomplete]="autoComplete.on"
      type="text" value="" [errorMessage]="errorMessageEnglish" [(ngModel)]="inputNgModelNojs"
      [label]="searchInputLabelEnglish"></maced-search>
    <maced-button buttonId="Secondary1" label="Submit" color="secondary" buttonType="submit"></maced-button>
  </form>
  <div>
    <h3>Result</h3>
    <div>
      Input value:-&nbsp;
      {{ inputNgModelNojs }}
    </div>
  </div>
</div>